import './index.less';
import { useTheme } from '@src/stores/useTheme';
import { useComputerData } from '@src/stores/useComputerData';
import { useEffect } from 'react';
import { themedIcon } from '@src/utils/icon';
interface Props {
  icon: string;
  children: React.ReactNode;
  id: string;
}
export const ToolCall = ({ icon, children, id }: Props) => {
  const { activeComputerDataById } = useComputerData();
  const { currentTheme } = useTheme();

  useEffect(() => {
    activeComputerDataById(id);
  }, [id]);

  const handleClick = () => {
    activeComputerDataById(id, { isMinimized: false });
  };

  return (
    <div className="tool-call-item" onClick={handleClick}>
      <img src={themedIcon(icon, currentTheme === 'dark')} alt="tool-call" />
      <div className="tool-call-item-content">{children}</div>
    </div>
  );
};
